export default __webpack_public_path__ + "static/media/dog-error.af1f6a90.jpg";